export class Report {
  public id : string
  public reportHeader : string;
  public displayQuery : string;
  public powerQuery : string;
  public synonyms : string[];
  public order : number;
}
export class PowerQuery {
  public id : string;
  public group : string;
  public groupHeader : string;
  public reports : Report[];
}
export class FlatQuery
{
  public reports : Report[];
}

export class FixedNotice
{
  public image : string;
  public title : string;
  public description : string;
}
export class PowerSearchDashboardConfig
{
  public id : string;
  public powerQueries : PowerQuery[];
  public flatQueries : FlatQuery[];
  public fixedNotice : FixedNotice;
  public taxNews : TaxNews[];
}

export class TaxNews
{
  public id : number;
  public imageUrl : string;
  public title : string;
  public description : any;
  public country : string;
}

export class Query {
  public group: string;
  public displayQuery: string;
  public powerQuery: string;
  public id: string;
  public reportId: string;

  constructor() {
    this.group = "";
    this.displayQuery = "";
    this.powerQuery = "";
    this.id = "";
    this.reportId = "";
  }
}
export class VisualizerEmbedReport {
  public EmbedToken : string;
  public DatasetId : string;
  public GroupId : string;
  public Id : string;
  public ProjectId : string;
  public ReportId : string;
  public ReportName : string;
  public ReportType : string;
  public TemplateId : string;
  public TemplateName : string;
  public TokenExpiration : string;
  constructor(payload) {
    this.EmbedToken = payload.embedToken || payload.EmbedToken;
    this.DatasetId = payload.datasetId || payload.DatasetId;
    this.GroupId = payload.groupId || payload.GroupId;
    this.Id = payload.id || payload.Id;
    this.ProjectId = payload.projectId || payload.ProjectId;
    this.ReportId = payload.reportId || payload.ReportId;
    this.ReportName = payload.reportName || payload.ReportName;
    this.ReportType = payload.reportType || payload.ReportType;
    this.TemplateId = payload.templateId || payload.TemplateID;
    this.TemplateName = payload.templateName || payload.TemplateName;
    this.TokenExpiration = payload.tokenExpiration || payload.TokenExpiration;
  }
}
export class ExpertCornerShortArticle {
  id: string;
  countryName: string;
  title: string;
  featureImageUrl: string;
  publicationDate: Date;
  shortContent: string;
  authors: Author[];
}
export class Author {
  firstName: string;
  lastName: string;
  companyName: string;
  position: string;
  avatarUrl: string;
}
